import React, { useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import { TicketPrint } from "../components/TicketPrint"
import { useReactToPrint } from "react-to-print";
import {shallowEqual, useSelector, useDispatch} from "react-redux";
import {actions} from "../_redux/ticketRedux";
import {onPrint} from "../requests";

const Ticket = ({ show, onHide }) => {
  const dispatch = useDispatch();
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onAfterPrint: () => dispatch(actions.afterPrintTrigger())
  });

  const {printType, printData} = useSelector((state) => state.ticket, shallowEqual);

  const onClickPrint = () => {
    onPrint(printType, printData.id)
        .then((res) => {
          handlePrint();
          dispatch(actions.setPrintData(res.data));
          onHide();
        })
        .catch(() => null)
  }


  return (
    <Modal
      size="md"
      show={show}
      aria-labelledby="create"
      centered
      className="pr-0"
      onHide={() => {}}
    >
      <Modal.Header>
        <Modal.Title id="create">Çap et</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="col-12 pl-4 pr-4 d-flex justify-content-center">
          <TicketPrint ref={componentRef} isScanner={true}/>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
            variant="info"
            onClick={onClickPrint}
        >
          Çap et
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default Ticket;
